<template>
  <div>
    <van-nav-bar title="发布闲置" left-text="返回" right-text left-arrow fixed @click-left="onClickLeft" />
    <div style="height:46px"></div>
    <div class="group">
      <div class="row">
        <div class="left">闲置类型</div>
        <div class="right" style="padding-top:15px">
          <van-radio-group v-model="item.type" direction="horizontal">
            <van-radio name="21" checked-color="#1baeae">转卖</van-radio>
            <van-radio name="19" checked-color="#1baeae">求购</van-radio>
          </van-radio-group>
        </div>
      </div>
    </div>

    <van-cell-group>
      <van-field v-model="item.title" label="标题" placeholder="闲置标题" />
      <van-field
        v-model="item.content"
        rows="3"
        autosize
        label="内容"
        type="textarea"
        maxlength="50"
        placeholder="请输入闲置物品内容"
        show-word-limit
      />
      <van-field v-model="item.lx_name" label="联系人" placeholder="联系人" />
      <van-field v-model="item.mobile" label="电话" type="tel" placeholder="电话" />
    </van-cell-group>
    <div class="group">
      <div class="row">
        <div class="left">省市</div>
        <div class="right">
          <van-dropdown-menu active-color="#1baeae">
            <van-dropdown-item
              v-model="item.province_id"
              :options="sheng_option"
              v-on:change="getCity(item.province_id)"
            />
            <van-dropdown-item v-model="item.city_id" :options="city_option" v-on:change="getArea(item.city_id)" />
            <van-dropdown-item v-model="item.district_id" :options="area_option" />
          </van-dropdown-menu>
        </div>
      </div>
    </div>
    <van-cell-group>
      <van-field v-model="item.address" label="详细地址" placeholder="详细地址" />
    </van-cell-group>
    <van-button type="danger" size="large" color="#1baeae" v-on:click="addNew()">发布闲置</van-button>
    <div class="photos">
      <van-uploader v-model="fileList" :preview-image='true' :before-read="beforeRead" :after-read="afterRead" max-count="5" />
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { RadioGroup, Radio } from "vant";
import { DropdownMenu, DropdownItem } from "vant";
import { Uploader } from "vant";

Vue.use(Uploader);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Radio);
Vue.use(RadioGroup);
export default {
  name: "secondAdd",
  data() {
    return {
      item: {
        type: "21",
        title: "",
        content: "",
        lx_name: "",
        mobile: "",
        address: "",
        province_id: 0,
        city_id: 0,
        district_id:0,
      },
      length: 50,
      user: { token: "" },
      sheng_option: [{ text: "选择省", value: 0 }],
      city_option: [{ text: "选择市", value: 0 }],
      area_option: [{ text: "选择区县", value: 0 }],
      fileList: [],
      img:[],
    };
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    afterRead(file) {
      file.status = 'uploading';
      file.message = '上传中...';

      var formData = new FormData();
      formData.append("file", file.file);
      this.$http
        .post( this.GLOBAL.API + "s_xianyu/Add/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            "XX-Token": this.user.token,
            "XX-Device-Type": "mobile"
          },
          processData: false,
          contentType: false,
          
        })
        .then(
          response => {
            let data = response.body;
            if (data.code == 1) {
                file.status="done",
                this.img.push(data.data);
            } else {
              this.$toast(data.msg);
            }
          }
        );
    },
    beforeRead() {
      return true;
    },
    addNew() {
      if(!this.img.length>=1){
          this.$toast('请上传一张图片试试，容易成交');
          return false;
      }
      this.$http
        .post(
          this.GLOBAL.API + "s_xianyu/Add/supply_add",
          {
            type: 21,
            title: this.item.title,
            img: this.img,
            content: this.item.title,
            province_id: this.item.province_id,
            city_id: this.item.city_id,
            district_id: this.item.district_id,
            mobile: this.item.mobile,
            address: this.item.address,
            buy_status: 0,
            lx_name: this.item.lx_name,
          },
          {
            params: {},
            headers: { "XX-Token": this.user.token, "XX-Device-Type": "mobile" }
          }
        )
        .then(response => {
          let data = response.body;
          if (data.code == 1) {
            this.$toast(data.msg);
            this.$router.go(-1);
          } else {
            this.$toast(data.msg);
          }
        });
    },
    getSheng() {
      this.$http
        .get(
          this.GLOBAL.API + "s_xianyu/Add/province",

          {
            params: {},
            headers: { "XX-Token": this.user.token, "XX-Device-Type": "mobile" }
          }
        )
        .then(response => {
          let data = response.body;
          if (data.code == 1) {
            for (let i in data.data) {
              this.sheng_option.push({
                text: data.data[i].area_name,
                value: data.data[i].area_id
              });
            }
          } else {
            this.$toast(data.msg);
          }
        });
    },
    getCity(id) {
      this.$http
        .get(
          this.GLOBAL.API + "s_xianyu/Add/child",

          {
            params: { area_id: id },
            headers: { "XX-Token": this.user.token, "XX-Device-Type": "mobile" }
          }
        )
        .then(response => {
          let data = response.body;
          if (data.code == 1) {
            for (let i in data.data) {
              this.city_option.push({
                text: data.data[i].area_name,
                value: data.data[i].area_id
              });
            }
          } else {
            this.$toast(data.msg);
          }
        });
    },
    getArea(id) {
      this.$http
        .get(
          this.GLOBAL.API + "s_xianyu/Add/child",

          {
            params: { area_id: id },
            headers: { "XX-Token": this.user.token, "XX-Device-Type": "mobile" }
          }
        )
        .then(response => {
          let data = response.body;
          if (data.code == 1) {
            for (let i in data.data) {
              this.area_option.push({
                text: data.data[i].area_name,
                value: data.data[i].area_id
              });
            }
          } else {
            this.$toast(data.msg);
          }
        });
    }
  },
  mounted() {
    if (JSON.parse(localStorage.getItem("user"))) {
      this.user = JSON.parse(localStorage.getItem("user"));
    }
    this.getSheng();
  }
};
</script>
<style lang="scss" scoped>
.row {
  display: flex;
  padding: 0 0 0 10px;

  .left {
    width: 90px;
    padding: 10px 0px 10px 8px;
    line-height: 30px;
    vertical-align: center;
    // border-bottom: 1px solid #ebedf0;
  }
  .right {
    flex-grow: 1;
    padding: 0;
    // border-bottom: 1px solid #ebedf0;
    ::v-deep .van-dropdown-menu__item {
      justify-content: left;
    }
    ::v-deep .van-hairline--top-bottom::after,
    .van-hairline-unset--top-bottom::after {
      border-width: 0px 0;
    }
  }
}
.photos {
  padding: 10px;
  text-align: left;
}
</style>